import { all, put, call, takeLatest } from 'redux-saga/effects';
import * as constants from '../../utils/constants';
import request from '../../utils/request';

export function* logFeedbackEventsData(data: any) {

  const APPLICATION_JSON = 'application/json';

  try {
    yield call(request, [
      'FEEDBACK',
      'FEEDBACK',
      null,
      '',
      data.payload,
      APPLICATION_JSON
    ]);

  } catch (e) {
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(constants.LPE_FEEDBACK_EVENTS, logFeedbackEventsData),
  ]);
}

